// extracted by mini-css-extract-plugin
module.exports = {"container":"add_container___h8hT","logo":"add_logo__RetbE","steps":"add_steps__3U45C","close-icon":"add_close-icon__3IF18"};